import SearchByLaximoWithNameContainer from "./components/SearchByLaximoWithNameContainer.jsx";

/**
 * Страница поиска запчастей по VIN автомобиля и названию запчасти
 * @returns {JSX.Element}
 */
export const SearchVehicleWithNamePage = () => {
    //TODO: Доработать. Создать обёртки.
    return (
        <SearchByLaximoWithNameContainer />
    );
};
